import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {allpayments} from "models/allpayments"; // Importing allpayments model
import {devConfig} from "config/config"; // Importing development configuration

/**
 * Class representing the table report view.
 * @extends JetView
 */
export default class tableReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config(){
        const _ = this.app.getService("locale")._; // Localization service
        return {
            rows: [{
                id: "preloader", // ID for the preloader
                cols: [
                    {
                        view:"datatable",id:"datatable", // DataTable view with ID 'datatable'
                        css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                        select:true, // Enable row selection
                        columns:[
                            { id:"Date", header:_("Fecha"), width:100, sort:"string"}, // Column for Date
                            { id:"NumberDeposist", header:_("Cantidad de depositos"), width:200, sort:"string"}, // Column for Number of Deposits
                            {
                                id: "ValueDeposist", header: _("Valor depositado"), width: 200, sort: "number", format: webix.i18n.priceFormat // Column for Value of Deposits
                            },
                            { id:"ValueReturnDeposits", header:_("Valor de depositos devueltos"), width:200, sort:"int", format: webix.i18n.priceFormat }, // Column for Value of Returned Deposits
                            { id:"NumberWithdrawalPaid", header:_("Cantidad de retiros pagados"), width:200, sort:"int" }, // Column for Number of Withdrawals Paid
                            { id:"ValuePaidWithdrawals", header:_("Valor de retiros pagados"), width:200, sort:"int", format: webix.i18n.priceFormat }, // Column for Value of Paid Withdrawals
                            { id:"TaxableBase", header:_("Base imponible"), width:200, sort:"int", format: webix.i18n.priceFormat }, // Column for Taxable Base
                            { id:"Tax", header:_("Impuesto"), width:200, sort:"number", format: webix.i18n.priceFormat }, // Column for Tax
                        ],
                        loadahead: 0, // Disable load ahead
                        datafetch:devConfig.getDefaultDataFetch(), // Fetch data configuration
                        pager: "pagerA" // Pager ID for pagination
                    }
                ]
            }
            ]
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid instance to initialize.
     */
    init(grid){
        grid = $$('datatable'); // Get the datatable instance
        const cur_user = this.getParam("user",true); // Get current user parameter
        var url = devConfig.geturlApi()+"null/Report/GetTaxPaymentsReport"; // API URL for fetching tax payments report
        var filter=""; // Initialize filter variable
        this.on(this.app,"taxPaymentsReport:filter",filterData => { // Event listener for filter updates
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1=""; // Initialize query string
            for(var i=0;i<object.length;i++){ // Iterate through filter entries
                if( (typeof object[i][1] !== "object") && (object[i][1] !== "") ){ // Check if value is not an object and not empty
                    if(object[i][0] == "Datepicker"){ // Handle date range filter
                        var date = object[i][1].split(" - ");
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query string
                    }else{
                        if(object[i][0] != "Date"){ // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to query string
                        }else{
                            if (object[i][0] == "Date") { // Handle single date filter
                                var date = object[i][1].replace(" 00:00:00","");
                                string1 = string1 + '&dateFrom=' + date; // Add date to query string
                                string1 = string1 + '&dateTo=' + date; // Add date to query string
                            }
                        }
                    }
                }else{
                    if( (typeof object[i][1] === "object")){ // Handle object type filters
                        var object2=Object.entries(object[i][1]); // Convert object to entries
                        for(var j=0;j<object2.length;j++){ // Iterate through object entries
                            if(object2[j][1]!==null){ // Check if value is not null
                                if(object2[j][0]==="start"){ // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom="dateFrom="+((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) +":"+ ("00" + d.getDate()).slice(-2) + " " +  ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" +  ("00" + d.getSeconds()).slice(-2);
                                    string1=string1+'&'+dateFrom; // Add start date to query string
                                }else{
                                    if(object2[j][0]==="end"){ // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo="dateTo="+((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) +":"+ ("00" + d.getDate()).slice(-2) + " " +  ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" +  ("00" + d.getSeconds()).slice(-2);
                                        string1=string1+'&'+ dateTo; // Add end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            grid.load(url+'?start=0&count='+grid.data.$pagesize+string1); // Load new data into the grid
            filter = string1; // Update filter variable
            $$("filterPopup").hide(); // Hide filter popup
        });
    }
}

// FILE DOCUMENTED
